export const ACTION_TYPES = {
  state: {
    update: "SELECT_STATE_UPDATED",
    reset: "SELECT_STATE_RESET"
  },
  subjects: {
    update: "SELECT_SUBJECTS_UPDATED",
    reset: "SELECT_SUBJECTS_RESET"
  },
  atar: {
    update: "ATAR_UPDATED",
    reset: "ATAR_RESET"
  },
  fields: {
    success: "FIELDS_SUCCESS",
    loading: "FIELDS_LOADING",
    failure: "FIELDS_FAILURE",
    reset: "FIELDS_RESET"
  },
  selectedFieldOfStudy: {
    update: "SELECT_FIELD_OF_STUDY",
    reset: "RESET_FIELD_OF_STUDY"
  },
  context: {
    success: "CONTEXT_SUCCESS",
    loading: "CONTEXT_LOADING",
    failure: "CONTEXT_FAILURE"
  },
  ug: {
    success: "UG_SUCCESS",
    loading: "UG_LOADING",
    failure: "UG_FAILURE"
  }
};
